(() => {
  document.querySelectorAll('[data-ariro-order]:not([data-initialized])').forEach((root) => {
    root.dataset.initialized = 'true';

    const storageKey = root.dataset.storageKey || 'ariro_b2b_order';
    const moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    const currency = root.dataset.currency || 'INR';
    const eventEndpoint = root.dataset.eventEndpoint || '';
    const salesUrl = root.dataset.salesUrl || '';

    let currentStep = 1;
    let activeCatalogTab = 'all';
    let quantities = {};
    let saveTimer;
    let sheetSyncTimer;
    let productSelectionTimer = null;
    let productSelectionOpen = false;
    let cartSnapshotTimer = null;

    const $ = (selector, context = root) => context.querySelector(selector);
    const $$ = (selector, context = root) => [...context.querySelectorAll(selector)];
    const orderItems = $$('[data-order-item]');

    const fields = {
      businessName: $('[name="business_name"]'),
      contactName: $('[name="contact_name"]'),
      email: $('[name="email"]'),
      phone: $('[name="phone"]'),
      gstNumber: $('[name="gst_number"]')
    };

    function trackBusinessField(eventName) {
      const email = fields.email?.value.trim() || '';
      const phone = fields.phone?.value.trim() || '';

      const url = new URL(
        'https://script.google.com/macros/s/AKfycbzT5myxLU0uDuQIKrdtQFCzHVGvvxp_ZRVSqkc1y4j_qqBSGKa5tfm-TzNFeDlTXJiuVQ/exec'
      );

      url.searchParams.set('email', email);
      url.searchParams.set('phone', phone);
      url.searchParams.set('event', eventName);
      url.searchParams.set(
  'timestamp',
  new Date().toISOString()
);
      url.searchParams.set('_t', Date.now().toString());

      fetch(url.toString(), {
        method: 'GET',
        mode: 'no-cors',
        cache: 'no-store'
      }).catch((error) => {
        console.warn('Business field tracking failed:', error);
      });
    }

    function trackProductSelection(eventName, products) {
  const email = fields.email?.value.trim() || '';
  const phone = fields.phone?.value.trim() || '';

  const url = new URL(
    'https://script.google.com/macros/s/AKfycbzT5myxLU0uDuQIKrdtQFCzHVGvvxp_ZRVSqkc1y4j_qqBSGKa5tfm-TzNFeDlTXJiuVQ/exec'
  );

  url.searchParams.set('email', email);
  url.searchParams.set('phone', phone);
  url.searchParams.set('event', eventName);
  url.searchParams.set('products', JSON.stringify(products));
  url.searchParams.set('_t', Date.now());

  const tracker = new Image();
  tracker.src = url.toString();
}

function getCurrentSelectedProducts() {
  return orderItems
    .map((item) => {
      const quantity = Number(
        quantities[getItemKey(item)] || 0
      );

      if (quantity <= 0) return null;

      return {
        product_name: item.dataset.title || '',
        quantity,
        item_type: item.dataset.itemType || '',
        variant_id: item.dataset.variantId || ''
      };
    })
    .filter(Boolean);
}

function scheduleCartSnapshot() {
  clearTimeout(cartSnapshotTimer);

  cartSnapshotTimer = setTimeout(() => {
    const products = getCurrentSelectedProducts();

    if (!products.length) return;

    trackProductSelection(
      'cart_snapshot',
      products
    );

    cartSnapshotTimer = null;
  }, 1500);
}

function sendSalesRequest() {
  const email = fields.email?.value.trim() || '';
  const phone = fields.phone?.value.trim() || '';
  const businessName = fields.businessName?.value.trim() || '';
  const contactName = fields.contactName?.value.trim() || '';
  const gstNumber = fields.gstNumber?.value.trim() || '';

  const products = getCurrentSelectedProducts();
  const totals = calculateTotals();

  const url = new URL(
    'https://script.google.com/macros/s/AKfycbzT5myxLU0uDuQIKrdtQFCzHVGvvxp_ZRVSqkc1y4j_qqBSGKa5tfm-TzNFeDlTXJiuVQ/exec'
  );

  url.searchParams.set('action', 'sales_request');

  url.searchParams.set('email', email);
  url.searchParams.set('phone', phone);
  url.searchParams.set('business_name', businessName);
  url.searchParams.set('contact_name', contactName);
  url.searchParams.set('gst_number', gstNumber);

  url.searchParams.set(
    'products',
    JSON.stringify(products)
  );

  url.searchParams.set(
    'mrp_total',
    String(totals.mrpTotal)
  );

  url.searchParams.set(
    'discount_total',
    String(totals.discount)
  );

  url.searchParams.set(
    'final_total',
    String(totals.subtotal)
  );

  url.searchParams.set(
    'timestamp',
    new Date().toISOString()
  );

  url.searchParams.set('_t', Date.now().toString());

  fetch(url.toString(), {
    method: 'GET',
    mode: 'no-cors',
    cache: 'no-store'
  }).catch((error) => {
    console.warn('Sales request failed:', error);
  });
}

function scheduleProductSelectionEvent() {
  productSelectionOpen = true;

  clearTimeout(productSelectionTimer);

  productSelectionTimer = setTimeout(() => {
    const products = getCurrentSelectedProducts();

    if (!products.length) {
      productSelectionOpen = false;
      return;
    }

    trackProductSelection(
      'product_selection_updated',
      products
    );

    productSelectionOpen = false;
    productSelectionTimer = null;
  }, 2 * 60 * 1000);
}

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(Number(cents || 0), moneyFormat);
      }

      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    }

    function getJourneyId() {
      const key = `${storageKey}_journey`;
      let id = localStorage.getItem(key);

      if (!id) {
        id = `b2b_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
        localStorage.setItem(key, id);
      }

      return id;
    }

    function getItemKey(item) {
      return item.dataset.itemKey;
    }

    function calculateTotals() {
      let units = 0;
      let selectedProducts = 0;
      let mrpTotal = 0;
      let subtotal = 0;

      orderItems.forEach((item) => {
        const quantity = Math.max(0, Number(quantities[getItemKey(item)] || 0));

        if (quantity > 0) selectedProducts += 1;
        units += quantity;
        mrpTotal += Number(item.dataset.mrp || 0) * quantity;
        subtotal += Number(item.dataset.price || 0) * quantity;
      });

      return {
        units,
        selectedProducts,
        mrpTotal,
        subtotal,
        discount: mrpTotal - subtotal
      };
    }

    function getSelectedItemsForTracking() {
      return orderItems
        .filter((item) => Number(quantities[getItemKey(item)] || 0) > 0)
        .map((item) => ({
          item_key: getItemKey(item),
          item_type: item.dataset.itemType || '',
          product_id: item.dataset.productId || '',
          variant_id: item.dataset.variantId || '',
          product_name: item.dataset.title || '',
          quantity: Number(quantities[getItemKey(item)] || 0),
          unit_price: Number(item.dataset.price || 0),
          unit_mrp: Number(item.dataset.mrp || 0)
        }));
    }

    async function trackEvent(eventName, extra = {}) {
      if (!eventEndpoint) return;

      const totals = calculateTotals();

      const payload = {
        journey_id: getJourneyId(),
        event_name: eventName,
        current_step: currentStep,
        active_catalog_tab: activeCatalogTab,
        business_name: fields.businessName?.value || '',
        contact_name: fields.contactName?.value || '',
        email: fields.email?.value || '',
        phone: fields.phone?.value || '',
        gst_number: fields.gstNumber?.value || '',
        selected_items: getSelectedItemsForTracking(),
        selected_products: totals.selectedProducts,
        selected_units: totals.units,
        mrp_total: totals.mrpTotal,
        discount_total: totals.discount,
        final_total: totals.subtotal,
        page_url: window.location.href,
        status: eventName === 'payment_started' ? 'Checkout Started' : 'Active',
        occurred_at: new Date().toISOString(),
        ...extra
      };

      try {
        await fetch(eventEndpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(payload),
          keepalive: true
        });
      } catch (error) {
        console.warn('Ariro event logging failed.', error);
      }
    }

    function scheduleSheetSync(eventName = 'business_details_updated') {
      clearTimeout(sheetSyncTimer);

      sheetSyncTimer = setTimeout(() => {
        trackEvent(eventName);
      }, 900);
    }

    async function syncBusinessEvent(eventName) {
  try {
    await fetch(eventEndpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify({
        email: fields.email?.value || '',
        phone: fields.phone?.value || '',
        event: eventName
      })
    });
  } catch (error) {
    console.log(error);
  }
}


    function saveDraft() {
      const saveState = $('[data-save-state] span');
      if (saveState) saveState.textContent = 'Saving...';

      clearTimeout(saveTimer);

      saveTimer = setTimeout(() => {
        localStorage.setItem(storageKey, JSON.stringify({
          currentStep,
          activeCatalogTab,
          quantities,
          businessName: fields.businessName?.value || '',
          contactName: fields.contactName?.value || '',
          email: fields.email?.value || '',
          phone: fields.phone?.value || '',
          gstNumber: fields.gstNumber?.value || ''
        }));

        if (saveState) saveState.textContent = 'All changes saved';
      }, 250);
    }

    function syncItemUI(item) {
      const quantity = Math.max(0, Number(quantities[getItemKey(item)] || 0));
      const input = $('[data-quantity]', item);
      if (input) input.value = quantity;

      item.classList.toggle('is-selected', quantity > 0);


    }

    

    function hydrate() {
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
        quantities = saved.quantities || {};
        currentStep = Math.min(Math.max(Number(saved.currentStep) || 1, 1), 3);
        activeCatalogTab = saved.activeCatalogTab || 'all';

        Object.entries(fields).forEach(([key, field]) => {
          if (field && saved[key]) field.value = saved[key];
        });

        orderItems.forEach((item) => {
          const key = getItemKey(item);
          quantities[key] = Math.max(0, Number(quantities[key] || 0));
          syncItemUI(item);
        });
      } catch (error) {
        quantities = {};
        currentStep = 1;
        activeCatalogTab = 'all';
      }
    }

    function showMessage(message) {
      const box = $('[data-message]');
      if (!box) return;
      box.textContent = message;
      box.hidden = !message;
    }

    function validateBusinessDetails() {
      const required = [fields.businessName, fields.contactName, fields.email, fields.phone];
      let valid = true;

      required.forEach((field) => {
        const empty = !field || !field.value.trim();
        field?.toggleAttribute('aria-invalid', empty);
        if (empty) valid = false;
      });

      if (fields.email?.value && !fields.email.checkValidity()) {
        fields.email.setAttribute('aria-invalid', 'true');
        valid = false;
      }

      showMessage(valid ? '' : 'Please complete the required business details before continuing.');
      return valid;
    }

    function updateTotals() {
      const totals = calculateTotals();

      $('[data-item-count]').textContent = `${totals.units} Item${totals.units === 1 ? '' : 's'}`;
      $('[data-summary-saving]').textContent = formatMoney(totals.discount);
      $('[data-summary-total]').textContent = formatMoney(totals.subtotal);
      $('[data-review-count]').textContent = `${totals.selectedProducts} product${totals.selectedProducts === 1 ? '' : 's'}`;
      $('[data-mrp-total]').textContent = formatMoney(totals.mrpTotal);
      $('[data-subtotal]').textContent = formatMoney(totals.subtotal);
      $('[data-discount-total]').textContent = `− ${formatMoney(totals.discount)}`;
      $('[data-final-total]').textContent = formatMoney(totals.subtotal);
      $('[data-saving-message]').textContent = `You save ${formatMoney(totals.discount)} on this order`;

      renderReview();
    }

    function setQuantity(item, value) {
      if (item.dataset.available !== 'true') return;

      const key = getItemKey(item);
      const previous = Number(quantities[key] || 0);
      const quantity = Math.max(0, Number.parseInt(value, 10) || 0);

      quantities[key] = quantity;
      syncItemUI(item);
      saveDraft();
      updateTotals();
     if (quantity !== previous) {
  scheduleProductSelectionEvent();
  scheduleCartSnapshot();
}

      let eventName = 'quantity_changed';
      if (previous === 0 && quantity > 0) eventName = item.dataset.itemType === 'kit' ? 'kit_added' : 'product_added';
      if (previous > 0 && quantity === 0) eventName = item.dataset.itemType === 'kit' ? 'kit_removed' : 'product_removed';

      trackEvent(eventName, {
        item_type: item.dataset.itemType,
        item_key: key,
        product_id: item.dataset.productId,
        variant_id: item.dataset.variantId,
        product_name: item.dataset.title,
        quantity
      });
    }

    function escapeHtml(value) {
      return String(value || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    function renderReview() {
      const list = $('[data-review-list]');
      if (!list) return;

      const selected = orderItems.filter((item) => Number(quantities[getItemKey(item)] || 0) > 0);

      if (!selected.length) {
        list.innerHTML = '<div class="ariro-order__review-empty">No products selected yet. Go back and add products to continue.</div>';
        return;
      }

      list.innerHTML = selected.map((item) => {
        const key = getItemKey(item);
        const quantity = Number(quantities[key] || 0);
        const lineTotal = Number(item.dataset.price || 0) * quantity;
        const image = item.dataset.image
          ? `<img src="${item.dataset.image}" alt="${escapeHtml(item.dataset.title)}" loading="lazy">`
          : '';
        const typeLabel = item.dataset.itemType === 'kit' ? '<span>Preschool Kit</span>' : '<span>Individual Product</span>';

        return `
          <div class="ariro-order__review-item">
            <div class="ariro-order__review-image">${image}</div>
            <strong class="ariro-order__review-name">
              ${escapeHtml(item.dataset.title)}
              ${typeLabel}
            </strong>

            <div class="ariro-order__review-qty">
              <button type="button" data-review-minus="${key}">−</button>
              <input type="number" min="0" value="${quantity}" data-review-input="${key}">
              <button type="button" data-review-plus="${key}">+</button>
            </div>

            <div class="ariro-order__review-price">${formatMoney(lineTotal)}</div>
          </div>
        `;
      }).join('');
    }

    function activateCatalogTab(tabId, log = true) {
      activeCatalogTab = tabId;

      $$('[data-catalog-tab]').forEach((button) => {
        const active = button.dataset.catalogTab === tabId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });

      $$('[data-catalog-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.catalogPanel === tabId);
      });

      saveDraft();

      if (log) {
        trackEvent('catalog_tab_viewed', {catalog_tab: tabId});
      }
    }

    function updateTopNavigation() {
      const backButton = $('[data-top-back]');
      const nextButton = $('[data-top-next]');
      const stepText = $('[data-top-step-text]');

      const stepNames = {
        1: 'Business Details',
        2: 'Select Products',
        3: 'Complete'
      };

      if (backButton) backButton.disabled = currentStep === 1;
      if (nextButton) nextButton.disabled = currentStep === 3;
      if (stepText) stepText.textContent = stepNames[currentStep] || '';
    }

    function goToStep(step) {
  const nextStep = Number(step);

  if (
    nextStep === 2 &&
    currentStep === 1 &&
    !validateBusinessDetails()
  ) {
    return;
  }

  if (nextStep === 2 && currentStep === 1) {
    trackBusinessField('moved_to_select_product');
  }

  currentStep = Math.min(Math.max(nextStep || 1, 1), 3);
  updateTopNavigation();

      $$('[data-step]').forEach((panel) => {
        panel.classList.toggle('is-active', Number(panel.dataset.step) === currentStep);
      });

      $$('[data-progress]').forEach((line) => {
        const number = Number(line.dataset.progress);
        line.classList.toggle('is-done', number < currentStep);
        line.classList.toggle('is-active', number === currentStep);
      });

      $$('[data-progress-label]').forEach((label) => {
        const number = Number(label.dataset.progressLabel);
        label.classList.toggle('is-done', number < currentStep);
        label.classList.toggle('is-active', number === currentStep);
      });

      $('[data-summary]')?.classList.remove('is-hidden');

      const summaryButton = $('[data-summary-next]');
      const summaryBar = $('[data-summary]');

if (summaryBar) {
  summaryBar.classList.toggle('is-payment-only', currentStep === 3);
}
      if (summaryButton) {
        summaryButton.textContent =
          currentStep === 1 ? 'Continue' :
          currentStep === 2 ? 'Complete' :
          'Proceed to Payment';
      }

      saveDraft();
      updateTotals();
      trackEvent('step_viewed', {step_number: currentStep});
      root.scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    function filterVariants() {
      const searchInput = $('[data-product-search]');
      const clearButton = $('[data-search-clear]');
      const term = (searchInput?.value || '').trim().toLowerCase();
      const variants = $$('[data-item-type="variant"]');
      let visible = 0;

      variants.forEach((item) => {
        const searchableText = (
          item.dataset.searchContent ||
          `${item.dataset.title || ''} ${item.dataset.category || ''}`
        ).toLowerCase();

        const show = !term || searchableText.includes(term);
        item.hidden = !show;

        if (show) visible += 1;
      });

      if (clearButton) {
        clearButton.hidden = !term;
      }

      $$('[data-search-suggestion]').forEach((button) => {
        const suggestion = (button.dataset.searchSuggestion || '').trim().toLowerCase();
        button.classList.toggle('is-active', Boolean(term) && suggestion === term);
      });

      const empty = $('[data-empty-search]');
      if (empty) empty.hidden = visible > 0;
    }

    function applySearchSuggestion(value) {
      const searchInput = $('[data-product-search]');
      if (!searchInput) return;

      searchInput.value = value;
      filterVariants();
      searchInput.focus();

      trackEvent('guided_search_used', {
        search_term: value
      });
    }

    async function proceedToCheckout() {
  const selectedItems = orderItems
    .filter((item) => {
      return Number(quantities[getItemKey(item)] || 0) > 0;
    })
    .map((item) => ({
      variantId: String(item.dataset.variantId),
      quantity: Number(quantities[getItemKey(item)] || 0)
    }));

  if (!selectedItems.length) {
    showMessage(
      'Add at least one product or kit before proceeding to payment.'
    );

    goToStep(2);
    return;
  }

  if (!validateBusinessDetails()) {
    goToStep(1);
    return;
  }

  const businessName = fields.businessName?.value.trim() || '';
  const contactName = fields.contactName?.value.trim() || '';
  const email = fields.email?.value.trim() || '';
  const phone = fields.phone?.value.trim() || '';
  const gstNumber = fields.gstNumber?.value.trim() || '';
  const journeyId = getJourneyId();

  /*
   * Split the contact person's full name.
   *
   * Example:
   * "Sindhiya Sridharan"
   * firstName = "Sindhiya"
   * lastName  = "Sridharan"
   */
  const nameParts = contactName
    .split(/\s+/)
    .map((part) => part.trim())
    .filter(Boolean);

  const firstName = nameParts.shift() || contactName;
  const lastName = nameParts.join(' ');

  const checkoutButton = $('[data-checkout]');

  if (checkoutButton) {
    checkoutButton.disabled = true;
    checkoutButton.textContent = 'Preparing checkout...';
  }

  showMessage('');

  await trackEvent('payment_started', {
    checkout_email: email,
    checkout_phone: phone
  });

  try {
    /*
     * Shopify cart permalink format:
     *
     * /cart/VARIANT_ID:QUANTITY,VARIANT_ID:QUANTITY
     */
    const cartItems = selectedItems
      .map((item) => {
        return `${item.variantId}:${item.quantity}`;
      })
      .join(',');

    /*
     * Everything here remains attached to the cart/order.
     */
    const orderNote = [
      'B2B Preschool Order',
      '',
      `Business Name: ${businessName}`,
      `Contact Person: ${contactName}`,
      `Email: ${email}`,
      `Phone: ${phone}`,
      `GST Number: ${gstNumber || 'Not provided'}`,
      `Journey ID: ${journeyId}`
    ].join('\n');

    const params = new URLSearchParams();

    /*
     * Order note
     */
    params.set('note', orderNote);

    /*
     * Structured order/cart attributes
     */
    params.set('attributes[Business Name]', businessName);
    params.set('attributes[Contact Person]', contactName);
    params.set('attributes[Contact Email]', email);
    params.set('attributes[Contact Phone]', phone);
    params.set(
      'attributes[GST Number]',
      gstNumber || 'Not provided'
    );
    params.set('attributes[Journey ID]', journeyId);
    params.set('attributes[Order Source]', 'Preschool Order Portal');

    /*
     * Official Shopify checkout-prefill fields
     */
    params.set('checkout[email]', email);
    params.set(
      'checkout[shipping_address][first_name]',
      firstName
    );

    if (lastName) {
      params.set(
        'checkout[shipping_address][last_name]',
        lastName
      );
    }

    /*
     * Phone is stored in the note and attributes.
     *
     * Shopify's documented cart-permalink checkout parameters
     * do not list the shipping phone field as officially supported.
     */

    const rootPath =
      window.Shopify?.routes?.root || '/';

    const checkoutUrl =
      `${rootPath}cart/${cartItems}?${params.toString()}`;

    window.location.href = checkoutUrl;

  } catch (error) {
    console.error('Checkout preparation failed:', error);

    showMessage(
      error.message ||
      'Checkout could not be prepared. Please try again.'
    );

    if (checkoutButton) {
      checkoutButton.disabled = false;
      checkoutButton.textContent = 'Proceed to Payment';
    }
  }
}
    orderItems.forEach((item) => {
      $('[data-minus]', item)?.addEventListener('click', () => {
        setQuantity(item, Number(quantities[getItemKey(item)] || 0) - 1);
      });

      $('[data-plus]', item)?.addEventListener('click', () => {
        setQuantity(item, Number(quantities[getItemKey(item)] || 0) + 1);
      });

      $('[data-quantity]', item)?.addEventListener('change', (event) => {
        setQuantity(item, event.target.value);
      });

    });

    root.addEventListener('click', (event) => {
        const topBackButton = event.target.closest('[data-top-back]');

if (topBackButton) {
  if (currentStep > 1) {
    goToStep(currentStep - 1);
  }

  return;
}

const topNextButton = event.target.closest('[data-top-next]');

if (topNextButton) {
  if (currentStep < 3) {
    goToStep(currentStep + 1);
  }

  return;
}
      const stepButton = event.target.closest('[data-go-step]');
      if (stepButton) {
        goToStep(stepButton.dataset.goStep);
        return;
      }

      if (event.target.closest('[data-browser-back]')) {
        window.history.back();
        return;
      }

      const tabButton = event.target.closest('[data-catalog-tab]');
      if (tabButton) {
        activateCatalogTab(tabButton.dataset.catalogTab);
        return;
      }

      const suggestionButton = event.target.closest('[data-search-suggestion]');
      if (suggestionButton) {
        applySearchSuggestion(suggestionButton.dataset.searchSuggestion || '');
        return;
      }

      if (event.target.closest('[data-search-clear]')) {
        const searchInput = $('[data-product-search]');
        if (searchInput) searchInput.value = '';
        filterVariants();
        searchInput?.focus();
        return;
      }

      const minus = event.target.closest('[data-review-minus]');
      if (minus) {
        const item = orderItems.find((entry) => getItemKey(entry) === minus.dataset.reviewMinus);
        if (item) setQuantity(item, Number(quantities[getItemKey(item)] || 0) - 1);
        return;
      }

      const plus = event.target.closest('[data-review-plus]');
      if (plus) {
        const item = orderItems.find((entry) => getItemKey(entry) === plus.dataset.reviewPlus);
        if (item) setQuantity(item, Number(quantities[getItemKey(item)] || 0) + 1);
        return;
      }

      if (event.target.closest('[data-summary-next]')) {

  if (currentStep < 3) {
    goToStep(currentStep + 1);
    return;
  }

  if (currentStep === 3) {
    proceedToCheckout();
    return;
  }
}

      if (event.target.closest('[data-checkout]')) {
        proceedToCheckout();
        return;
      }

     if (event.target.closest('[data-sales]')) {

  sendSalesRequest();

  trackBusinessField('sales_team_requested');

  showMessage(
    'Your order details have been sent to our sales team, they shall connect with you soon'
  );

  const messageBox = $('[data-message]');

  if (messageBox) {
    messageBox.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  return;
}
    });

    root.addEventListener('change', (event) => {
      const input = event.target.closest('[data-review-input]');
      if (!input) return;

      const item = orderItems.find((entry) => getItemKey(entry) === input.dataset.reviewInput);
      if (item) setQuantity(item, input.value);
    });

  Object.values(fields).forEach((field) => {
  field?.addEventListener('input', () => {
    saveDraft();
  });
});

fields.email?.addEventListener('blur', () => {
  const email = fields.email.value.trim();

  if (email) {
    trackBusinessField('email_began_business_form');
  }
});

fields.phone?.addEventListener('blur', () => {
  const phone = fields.phone.value.trim();

  if (phone) {
    trackBusinessField('working_in_business_form');
  }
});

    $('[data-product-search]')?.addEventListener('input', filterVariants);

    $('[data-product-search]')?.addEventListener('change', (event) => {
      const value = event.target.value.trim();
      if (value) {
        trackEvent('product_search_used', {
          search_term: value
        });
      }
    });
    
    hydrate();
    activateCatalogTab(
      $('[data-catalog-panel="' + activeCatalogTab + '"]') ? activeCatalogTab : 'all',
      false
    );
    updateTotals();
    goToStep(currentStep);
    trackEvent('form_opened');


window.addEventListener('pageshow', () => {
  const button = document.querySelector('[data-checkout]');

  if (!button) return;

  button.disabled = false;
  button.textContent = 'Proceed to Payment';
});
  });
})();

